import { FC } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas'

import { PatientForm, PatientFormShape } from '../PatientForm'
import { ID } from '@models/base'

type Props = {
  isShow: boolean
  title: React.ReactNode
  initialValues?: PatientFormShape
  patientId?: ID
  onClose: () => void
  onSubmit: (values: PatientFormShape) => Promise<void>
}

const PatientFormDrawer: FC<Props> = ({ isShow, title, initialValues, patientId, onClose, onSubmit }) => {
  return (
    <Offcanvas
      placement="end"
      show={isShow}
      onHide={onClose}
      style={{ width: '50vw' }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title as="h2">{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <PatientForm
          patientId={patientId}
          initialValues={initialValues}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export { PatientFormDrawer }
